import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TabContext } from '@mui/lab';

import ProductsFixturesTab from '../view/ProductsFixturesTab';

import StyledTabs from '../../../styled/Tabs';
import StyledTab from '../../../styled/Tab';
import StyledTabPanel from '../../../styled/TabPanel';
import ElementInfo from '../view/ElementInfo';
import apiClient from '../../../../services/api';
import { setSelectedMeshId } from '../../../../store/actions/Project';
import { useSelector } from 'react-redux';
import { getSelectedObject } from '../helpers';
import ProductsBackgroundsTab from '../view/ProductsBackgroundsTab';

function Sidebar() {
    const [selectedTab, setSelectedTab] = useState('products');
    const [isBackgroundsModuleActive, setIsBackgroundModulesActive] = useState(false);

    const selectedMeshId = useSelector((state) => state.project.selectedMeshId);
    const projectElements = useSelector((state) => state.project.elements);

    const handleChangeTab = (event, newTab) => { setSelectedTab(newTab) };
    
    const { t } = useTranslation();

    useEffect(() => {
        apiClient.post('/api/modules/check', { name: 'backgrounds' }).then(response => {
            setIsBackgroundModulesActive(response?.data?.success);
        });
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isBackgroundsModuleActive && selectedMeshId) {
            const selectedObject = getSelectedObject(projectElements, selectedMeshId);

            if (selectedObject?.is_product) {
                setSelectedTab('backgrounds');
            }

            return;
        }

        const selectedElement = projectElements?.filter(element => element.external_id == selectedMeshId);

        if (!selectedElement || selectedElement?.length === 0) {
            return;
        }

        const isProduct = selectedElement[0]?.is_product;

        if (selectedTab == 'fixtures' && isProduct) {
            setSelectedTab('products');
        } else if (selectedTab == 'products' && !isProduct) {
            setSelectedTab('fixtures');
        }
    }, [isBackgroundsModuleActive, selectedMeshId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <ElementInfo />
            <TabContext value={selectedTab}>
                <StyledTabs
                    value={selectedTab}
                    onChange={handleChangeTab}
                    textColor="inherit"
                    variant="fullWidth"
                >
                    <StyledTab label={t('Products')} value="products" />
                    <StyledTab label={t('Fixtures')} value="fixtures" />
                    {isBackgroundsModuleActive && <StyledTab label={t('Backgrounds')} value="backgrounds" />}
                </StyledTabs>
                
                <StyledTabPanel value="products">
                    <ProductsFixturesTab type="products" isPublic={true} />
                </StyledTabPanel>
                
                <StyledTabPanel value="fixtures">
                    <ProductsFixturesTab type="fixtures" isPublic={true} />
                </StyledTabPanel>

                {isBackgroundsModuleActive &&
                    <StyledTabPanel value="backgrounds" style={{ paddingRight: '5px', overflowY: 'auto' }}>
                        <ProductsBackgroundsTab />
                    </StyledTabPanel>
                }
            </TabContext>
        </>
    );
}

export default Sidebar;
